import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/6tn3nxvq_Logo-urba2c.jpg" 
                alt="URBA-2C Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-sm leading-relaxed">
              Bureau d'études spécialisé dans les autorisations d'urbanisme pour particuliers et professionnels.
            </p>
            <p className="text-sm mt-4 text-pink-400 font-medium">
              25 ans d'expérience
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-pink-400 transition-colors">Accueil</Link>
              </li>
              <li>
                <Link to="/presentation" className="text-sm hover:text-pink-400 transition-colors">Présentation</Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-pink-400 transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/galerie" className="text-sm hover:text-pink-400 transition-colors">Galerie</Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-pink-400 transition-colors">Contact</Link>
              </li>
              <li>
                <Link to="/cgv" className="text-sm hover:text-pink-400 transition-colors">CGV</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Mes services</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start">
                <span className="text-pink-400 mr-2">•</span>
                <span>Permis de construire</span>
              </li>
              <li className="flex items-start">
                <span className="text-pink-400 mr-2">•</span>
                <span>Déclaration préalable</span>
              </li>
              <li className="flex items-start">
                <span className="text-pink-400 mr-2">•</span>
                <span>Certificat d'urbanisme</span>
              </li>
              <li className="flex items-start">
                <span className="text-pink-400 mr-2">•</span>
                <span>Plans 2D - 3D</span>
              </li>
              <li className="flex items-start">
                <span className="text-pink-400 mr-2">•</span>
                <span>Conseil urbanisme</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:0761926962" className="flex items-start space-x-3 text-sm hover:text-pink-400 transition-colors group">
                  <Phone className="w-5 h-5 flex-shrink-0 mt-0.5 text-pink-400" />
                  <span>07.61.92.69.62</span>
                </a>
              </li>
              <li>
                <a href="mailto:contact@urba2c.fr" className="flex items-start space-x-3 text-sm hover:text-pink-400 transition-colors group">
                  <Mail className="w-5 h-5 flex-shrink-0 mt-0.5 text-pink-400" />
                  <span>contact@urba2c.fr</span>
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Clock className="w-5 h-5 flex-shrink-0 mt-0.5 text-pink-400" />
                <div>
                  <p>Lun - Ven: 9h - 18h</p>
                  <p className="text-xs text-gray-400">Sur rendez-vous</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} URBA-2C. Tous droits réservés.
            </p>
            <p className="text-sm text-gray-400">
              L'autorisation d'urbanisme, la clé de votre projet.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;